module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-red-nav"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('ul', {
    staticClass: "list-basic-settings",
    attrs: {
      "id": "red-nav-navbar"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "row-red-nav-a",
    attrs: {
      "href": _vm.apiLinks.selfHome,
      "target": "_blank"
    }
  }, [_vm._v("返回官网")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "row-red-nav-a",
    attrs: {
      "href": "home.html"
    }
  }, [_vm._v("首页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "row-red-nav-a",
    attrs: {
      "href": "purchase.html"
    }
  }, [_vm._v("招采信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "row-red-nav-a",
    attrs: {
      "target": "_blank",
      "href": "contact.html"
    }
  }, [_vm._v("联系我们")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/template-compiler?{"id":"data-v-6587ab68","hasScoped":false}!./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-rednav.vue
// module id = 23
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17